import React from 'react';
import { motion } from 'framer-motion';
import { Avatar, Box, Button, Card, Grid, Paper, Rating, Typography } from '@mui/material';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Link } from 'react-router-dom';
import Header from '../../Layout/Header/header';
import Footer from '../../Layout/Footer/footer';
import AboutPortFolio from './aboutPortfolio';
import TeamCarousel from './ourTeam';
import img from "../../images/girlfriend-asking-your-jacket-feel-chilly-spring-cold-evening-wearing-t-shirt-hugging-herself-emrace-cross-arms-smiling-romantic 1.svg"


const contentVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
  out: { opacity: 0, y: -20 },
};

const contentTransition = {
  type: 'spring',
  stiffness: 120,
  damping: 20,
  duration: 0.3,
};

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1.3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const testimonials = [
  {
    name: 'Criss Type',
    rating: 4,
    message: '“Thanks to Home Well Done, my home renovation project was a breeze. Their expert guidance and project management skills made everything smooth and stress-free. Highly recommended!"',
    image: img,
  },
  {
    name: 'Criss Type',
    rating: 4,
    message: '“Thanks to Home Well Done, my home renovation project was a breeze. Their expert guidance and project management skills made everything smooth and stress-free. Highly recommended!"',
    image: img,
  },
  {
    name: 'Criss Type',
    rating: 4,
    message: '“Thanks to Home Well Done, my home renovation project was a breeze. Their expert guidance and project management skills made everything smooth and stress-free. Highly recommended!"',
    image: img,
  },
];

const AboutUs = () => {
  return (
    <Box sx={{ maxWidth: '2000px', margin: '0 auto', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box sx={{ flex: 1 }}>
        <motion.div
          variants={contentVariants}
          initial="initial"
          animate="in"
          exit="out"
          transition={contentTransition}
        >
          <Box sx={{ py: { xs: 2, sm: 3, md: 3, lg: 3, xl: 3 }, px: { xs: 2, md: 6.4 } }}>
            <Grid container spacing={{ xs: 3, md: 5 }} alignItems="center">
              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container alignItems="center" spacing={2}>
                      <Grid item>
                        <Typography
                          sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontWeight: 700,
                            color: '#333333',
                            fontSize: { xs: '22px', md: '32px' },
                          }}
                        >
                          About Meegloo
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: '16px',
                        lineHeight: '28px',
                        fontFamily: 'Roboto',
                        maxWidth: '90%',
                      }}
                    >
                      At meegloo, we believe your dream home should come with joy—not stress. That’s why we’re redefining the home-building experience, one project at a time.
                      A home is where the first steps are taken, where laughter echoes, where life unfolds. We understand the emotions behind every blueprint.
                      From blueprint to final brushstroke, we manage everything—so you don’t have to.
                      No more chasing contractors, juggling timelines, or second-guessing quality. With us, you get an end-to-end, transparent, and timely journey where every corner we craft carries your vision, every brick holds our promise of quality.
                      You shouldn’t just build a home—you should feel at home every step of the way.
                      Because, every journey starts from home.
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      component={Link}
                      to="/contact-us"
                      sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: { xs: '16px', sm: '19px', md: '20px', lg: '20px', xl: '20px' },
                        borderRadius: '20px',
                        background: '#89652A',
                        textTransform: 'capitalize',
                        color: 'white',
                        fontWeight: 700,
                        padding: '4px 22px',
                      }}
                    >
                      Contact
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <Paper
                  elevation={0}
                  sx={{ borderRadius: 4, overflow: 'hidden', height: { xs: 300, md: 318 } }}
                >
                  <img
                    src="https://img.freepik.com/free-photo/civil-engineer-construction-worker-manager-holding-digital-tablet-blueprints-talking-planing-about-construction-site-cooperation-teamwork-concept_640221-156.jpg?t=st=1733833563~exp=1733837163~hmac=902234e08b4cab7c9050cc5e849b13b3e6560bc2d94360bca9ea35cd508ff58f&w=900"
                    alt="about-img"
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                  />
                </Paper>
              </Grid>
            </Grid>
          </Box>
          {/* <Box sx={{ py: { xs: 1, md: 3 }, px: { xs: 0 } }}>
            <AboutPortFolio />
          </Box> */}
          {/* <TeamCarousel /> */}
          {/* <Box>
            <Typography
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                mt: { xs: 1, md: 0.5 },
                fontSize: { xs: '27px', md: '50px' },
                fontWeight: 700,
                textAlign: 'center',
                color: '#333333',
              }}
            >
              What People Say About Us
            </Typography>
            <Carousel
              responsive={responsive}
              swipeable
              draggable
              customTransition="transform 500ms ease-in-out"
              transitionDuration={500}
              infinite
              autoPlay
              autoPlaySpeed={2000}
              keyBoardControl
              arrows={false}
              showDots
              dotListClass="custom-dot-list"
              className="say-about-us-dots-height"
            >
              {testimonials.map((testimonial, index) => (
                <Card
                  elevation={0}
                  key={index}
                  sx={{
                    borderRadius: '20px',
                    p: 2,
                    backgroundColor: '#f4f4f4',
                    display: 'flex',
                    alignItems: 'center',
                    m: 2,
                  }}
                >
                  <Avatar
                    src={testimonial.image}
                    alt={testimonial.name}
                    sx={{
                      boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',
                      width: 120,
                      border: '1px solid #FFFFFF',
                      height: 180,
                      borderRadius: { xs: '35px', md: '46px' },
                      mr: 2,
                    }}
                  />
                  <Box>
                    <Typography sx={{ fontWeight: 700, fontSize: '22px', mb: 1 }}>
                      {testimonial.name}
                    </Typography>
                    <Rating
                      name="read-only"
                      value={testimonial.rating}
                      readOnly
                      size="small"
                      sx={{ mb: 2, color: 'black' }}
                    />
                    <Typography sx={{ fontSize: '13px', fontWeight: 400 }}>
                      {testimonial.message}
                    </Typography>
                  </Box>
                </Card>
              ))}
            </Carousel>
          </Box> */}
        </motion.div>
      </Box>
      <Footer />
    </Box>
  );
};

export default AboutUs;